/* 
  This now renamed from model variant to model variant however the file name is not changed to avoid conflicts with existing imports.
*/
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './ModelVariant.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialModelVariantState } from '../../reducers/initialState';
import { v4 as uuidv4 } from 'uuid';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { Navigate, Link, useParams, href } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Checkbox from '../WSAControls/CheckboxContainer/Checkbox';
import ModelConfigurationContentTemplate from '../ModelTab/ModelConfigurationContentTemplate';
import classNames from 'classnames';
import { isRequired } from '../../utils';
import { v4 as uuid } from 'uuid';
import Cookies from 'js-cookie';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb';

const ModelVariant = ({
  saveModelVariant,
  describeModel,
  modelManager,
  describeModelVariant,
  modelVariantManager = {
    ...initialModelVariantState.modelVariantManager
  },
  changeModelVariant,
  userProfileWidgets,
  intl
}) => {
  let IsEdit = false;
  let IsDuplicate = false;
  let IsRedirect = false;
  let heading = '';
  const [DuplicateSetpoint, setDuplicateSetpoint] = useState(true);
  const [DuplicateThreshold, setDuplicateThreshold] = useState(true);
  const [localformErrors, setFormErrors] = useState({});
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  let { ModelVariantId, Duplicate, ModelId, ModelCategoryId } = useParams();

  if (ModelVariantId) {
    IsEdit = true;
    if (Duplicate) {
      IsDuplicate = true;
      heading = intl.formatMessage({ id: 'modelVariant.duplicateModelVariant', defaultMessage: 'Duplicate Model Variant' });
    } else {
      heading = intl.formatMessage({ id: 'modelVariant.editModelVariant', defaultMessage: 'Edit Model Variant' });
    }
  }
  else {
    heading = intl.formatMessage({ id: 'modelVariant.addModelVariant', defaultMessage: 'Add Model Variant' });
  }

  let widgetCode = ModelVariantId ? (Duplicate ? 'MODELVARIANTDUPLICATE' : 'MODELVARIANTUPDATE') : 'MODELVARIANTADD';

  useEffect(() => {
    if (ModelId && !ModelVariantId) {
      describeModel(ModelId, widgetCode, ModelCategoryId);
    }
  }, [describeModel, ModelId, ModelVariantId, widgetCode, ModelCategoryId]);

  useEffect(() => {
    if (ModelVariantId) {
      if (Duplicate) {
        describeModelVariant(ModelVariantId, Duplicate, widgetCode, ModelCategoryId);
      } else {
        describeModelVariant(ModelVariantId, null, widgetCode, ModelCategoryId);
      }
    }
  }, [describeModelVariant, ModelVariantId, Duplicate, widgetCode, ModelCategoryId]);


  //clean up
  useEffect(() => {
    return () => {
      changeModelVariant({
        ...modelVariantManager,
        selectedModelVariant: { ...initialModelVariantState.modelVariantManager.selectedModelVariant }
      });
    };
  }, []);

  // Update redux store
  const setLocalModelVariant = currentState => {
    changeModelVariant(currentState);
  };
  //Saving
  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }

    let saveData = modelVariantManager.selectedModelVariant;
    saveData.IsEdit = IsEdit;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    saveData.ModelCategoryId = ModelCategoryId;
    saveData.OrganisationId = IsDuplicate ? saveData.OrganisationId : Cookies.get(`selectedorganisationid-${envName}`) || 1;

    if (!IsEdit) {
      saveData.ModelId = ModelId;
      saveData.ModelVariantId = 0;
      saveData.GuidIdentifier = uuidv4();
    }

    if (IsDuplicate) {
      saveData.RefModelVariantId = ModelVariantId;
      saveData.RefModelId = ModelId;
      saveData.IsDuplicate = IsDuplicate;
      saveData.DuplicateSetpoint = DuplicateSetpoint;
      saveData.DuplicateThreshold = DuplicateThreshold;
      saveData.GuidIdentifier = uuidv4();
    }

    //saving Model Variant
    saveModelVariant(saveData, widgetCode);
  };

  const validateInput = () => {
    let formErrors = {};
    let isValid = true;

    if (
      !modelVariantManager ||
      !modelVariantManager.selectedModelVariant ||
      !modelVariantManager.selectedModelVariant.Name ||
      isRequired(modelVariantManager.selectedModelVariant.Name, 1)
    ) {
      formErrors.Name = intl.formatMessage({
        id: 'modelVariant.nameMandatory',
        defaultMessage: 'Variant name is a mandatory field'
      });
      isValid = false;
    }

    setFormErrors(formErrors);

    return isValid;
  };

  //on control value change
  const onChange = e => {
    if (e.target && e.target.type && e.target.type === 'checkbox') {
      setLocalModelVariant({
        ...modelVariantManager,
        selectedModelVariant: { ...modelVariantManager.selectedModelVariant, [e.target.name]: e.target.checked }
      });
    } else {
      setLocalModelVariant({
        ...modelVariantManager,
        selectedModelVariant: { ...modelVariantManager.selectedModelVariant, [e.target.name]: e.target.value }
      });
    }
  };

  const organisationOptions = () => {
    let organisationData = [];

    modelVariantManager.selectedModelVariant.availableOrganisations &&
      modelVariantManager.selectedModelVariant.availableOrganisations.length > 0 &&
      modelVariantManager.selectedModelVariant.availableOrganisations.forEach(element => {
        organisationData.push({
          label: element.Name,
          value: element.OrganisationId
        });
      });
    return organisationData;
  };

  const onOrganisationOptionsChange = e => {
    setLocalModelVariant({
      ...modelVariantManager,
      selectedModelVariant: { ...modelVariantManager.selectedModelVariant, OrganisationId: parseInt(e.value) }
    });
  };


  let messageId = (modelVariantManager && modelVariantManager.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const returnUrl = `/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variants-list`;

  const labelText = modelVariantManager.selectedModelVariant.Name ? `${heading} ${modelVariantManager.selectedModelVariant.Name} ` : `${heading}`;

  const breadcrumbItems = [
    { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
    { label: <FormattedMessage id="model.models" defaultMessage="Models" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-list` },
    { label: <FormattedMessage id="model.modelvariant" defaultMessage="Model Variants" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variants-list` },
    { label: labelText } // Last item has no href (current page)
  ];

  return (
    <div className={s.modelvariant}>
      {modelManager.isLoading || (modelVariantManager.isLoading && <LoadingSpinner />)}
      {modelVariantManager.isOpSuccessful && !modelVariantManager.showBanner ? <Navigate to={returnUrl} /> : ''}
      {IsRedirect ? <Navigate to={returnUrl} /> : ''}
      <Banner
        key={uuid()}
        failureText={messageText}
        showBanner={modelVariantManager.showBanner}
        status={modelVariantManager.isOpSuccessful}
        successText={messageText}
      />

      <ModelConfigurationContentTemplate selectedPage="manageModelVariants" userProfileWidgets={userProfileWidgets} intl={intl}>
        <div className={s.contentWrapper}>
          <div className={s.modelvariantHeader}>
            <h3>{heading}</h3>
          </div>
          <div className='pb-3'>
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <div className={s.modelvariantContent}>
            <Form>
              {IsDuplicate && (
                <Row>
                  <Col lg={6}>
                    <Form.Group controlId="formModelVariantName">
                      <Form.Label>
                        <FormattedMessage id="modelVariantManagement.Organisation" defaultMessage="Organisation" />
                      </Form.Label>

                      <Dropdown
                        id="drpOrgId"
                        dataArray={organisationOptions()}
                        controlData={{
                          placeholderText: (
                            <FormattedMessage id="modelVariantManagement.selectOrganisation" defaultMessage="Select Organisation" />
                          ),
                          customClassName: ''
                        }}
                        onDropdownChange={e => onOrganisationOptionsChange(e)}
                        selectedOption={organisationOptions().filter(
                          option => option.value === modelVariantManager.selectedModelVariant.OrganisationId
                        )}
                        disabled={false}
                      />
                      {localformErrors && localformErrors.OrganisationId && (
                        <p role="alert" className={s.error}>
                          {localformErrors.OrganisationId}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              )}
              <Row>
                <Col lg={6}>
                  <Form.Group controlId="formModelVariantName">
                    <Form.Label>
                      <FormattedMessage id="modelVariantManagement.versionName" defaultMessage="Variant Name" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="Name"
                      onChange={onChange}
                      value={modelVariantManager.selectedModelVariant.Name}
                      className={`${s.formControl} ${localformErrors && localformErrors.Name ? s.formControlError : ''}`}
                    />
                    {localformErrors && localformErrors.Name && (
                      <p role="alert" className={s.error}>
                        {localformErrors.Name}
                      </p>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={6}>
                  <Form.Group controlId="formModelVariantDescription">
                    <Form.Label>
                      <FormattedMessage id="modelVariantManagement.description" defaultMessage="Variant Description" />
                    </Form.Label>

                    <Form.Control
                      as="textarea"
                      rows="3"
                      name="Description"
                      onChange={onChange}
                      placeholder={intl.formatMessage({
                        id: 'modelVariantManagement.enterDescription',
                        defaultMessage: 'Enter description'
                      })}
                      value={modelVariantManager.selectedModelVariant.Description}
                      className={`${s.textArea} ${localformErrors && localformErrors.Description ? s.formControlError : ''}`}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {IsDuplicate && (

                <Row>
                  <Col lg={3}>
                    <Form.Group controlId="ModelVariantSetpoint">
                      <Checkbox
                        key={uuidv4()}
                        dataArray={[
                          {
                            SKEY: 'DuplicateSetpoint',
                            target: { type: 'checkbox' },
                            label: intl.formatMessage({
                              id: 'modelVariantManagement.duplicateModelVariantSetpoints',
                              defaultMessage: 'Duplicate Model Variant Setpoints'
                            }),
                            isChecked: DuplicateSetpoint
                          }
                        ]}
                        onSelectionChange={(e) => setDuplicateSetpoint(e.target.checked)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={3}>
                    <Form.Group controlId="ModelVariantThreshold">
                      <Checkbox
                        key={uuidv4()}
                        dataArray={[
                          {
                            SKEY: 'DuplicateThreshold',
                            target: { type: 'checkbox' },
                            label: intl.formatMessage({
                              id: 'modelVariantManagement.duplicateModelVariantThresholds',
                              defaultMessage: 'Duplicate Model Variant Thresholds'
                            }),
                            isChecked: DuplicateThreshold
                          }
                        ]}
                        onSelectionChange={(e) =>  setDuplicateThreshold(e.target.checked)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

              )}
              <Row>
                <Col>
                  <Form.Group controlId="formActiveModelVariant">
                    <Checkbox
                      key={uuidv4()}
                      dataArray={[
                        {
                          SKEY: 'IsActive',
                          target: { type: 'checkbox' },
                          label: intl.formatMessage({
                            id: 'modelVariantManagement.active',
                            defaultMessage: 'Variant is active'
                          }),
                          isChecked: modelVariantManager.selectedModelVariant.IsActive
                        }
                      ]}
                      onSelectionChange={onChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div>
                <Button
                  variant="primary"
                  className={classNames(s.margin5, s.btnSaveChanges)}
                  onClick={submitForm}
                  noValidate
                  data-unittest="saveData"
                >
                  <FormattedMessage id="modelVariantManagement.saveModelVariant" defaultMessage="SAVE CHANGES" />
                </Button>
                <Link to={returnUrl}>
                  <Button variant="outline-secondary" className={s.btnCancel}>
                    <FormattedMessage id="modelVariantManagement.cancelModelVariant" defaultMessage="CANCEL" />
                  </Button>
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </ModelConfigurationContentTemplate>
    </div>
  );
};

ModelVariant.propTypes = {
  saveModelVariant: PropTypes.func.isRequired,
  modelVariantManager: PropTypes.object.isRequired,
  describeModelVariant: PropTypes.func.isRequired,
  changeModelVariant: PropTypes.func.isRequired,
  userProfileWidgets: PropTypes.object.isRequired
};

export default injectIntl(ModelVariant);
